<template>
    <div class="inline-block">
        <span class="icon-caret el-icon-caret-right"
              :class="[isActive?'rotate':'']"></span>
        <div class="inline-block ml6" @click.stop>
            <el-checkbox :value="module.checked" :disabled="isView||module.disabled" @change="changeModule">
                <span class="text-bold font14px">{{module.display_name}}</span>
            </el-checkbox>
            <span class="ml20 font12px check-btn" @click="handleCheckAllChange(module)" v-if="!isView">全选</span>

            <div class="data-dimension-config ml50 inline-block" v-if="module.name=='data_query_analysis'&&dataDays=='2'">
                数据日期权限配置：
                <el-radio-group v-model="module.data_days_global" @change="changeDataDaysGlobal" :disabled="isView">
                    <el-radio label="1">最近
                        <el-input v-model="module.data_days" size="mini" @change="changeDataDays" :disabled="isView||module.data_days_global=='2'" :class="isInputErr?'input-err':''" style="width: 60px;"></el-input>
                        天</el-radio>
                    <el-radio label="2">不限</el-radio>
                </el-radio-group>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CollapseTitle",
        props: {
            module:{
                type: Object,
                default: function () {
                    return {}
                }
            },
            isActive:{
                type: Boolean,
                required:true,
            },
            isView:{
                type: Boolean,
                required:false,
                default:false,
            },
            dataDays:{
                type:[String,Number]
            }
        },
        data(){
            return {
                isInputErr:false,
            }
        },
        methods:{
            handleCheckAllChange(){
                if(this.module.disabled&&this.module.name!='home') return;
                this.$emit('title-check-all',this.module);
            },
            changeModule(val){
                this.$emit('change-module',val,this.module);
            },
            changeDataDaysGlobal(val){
                console.log('changeDataDaysGlobal',val);
                // this.validateDataDays();
                if(val=='2'){
                    this.isInputErr = false;
                    if(this.module.data_days<=0){
                        this.module.data_days = null;
                    }
                }
            },
            changeDataDays(val){
                console.log('changeDataDays',val);
                this.validateDataDays();
            },
            validateDataDays(){
                if(this.module.data_days_global=='2') {
                    this.isInputErr = false;
                }else if(!this.module.data_days){
                    this.$message.error('数据日期天数不可为空');
                    this.isInputErr = true;
                }else if(isNaN(this.module.data_days)){
                    this.$message.error('数据日期天数格式不正确');
                    this.isInputErr = true;
                }else if(this.module.data_days>1000){
                    this.$message.error('数据日期天数不能大于1000天');
                    this.isInputErr = true;
                }else if(parseInt(this.module.data_days)!=this.module.data_days){
                    this.$message.error('数据日期天数请填写整数');
                    this.isInputErr = true;
                }else if(this.module.data_days<=0){
                    this.$message.error('数据日期天数需大于0');
                    this.module.data_days = null;
                    this.isInputErr = true;
                }else{
                    this.isInputErr = false;
                }

            },
        }
    }
</script>

<style lang="scss" scoped>
    .icon-caret {
        transition: all .5s;
        font-size: 18px;
        margin-top: -2px;
    }
    .rotate {
        transform: rotate(90deg);
    }
    .check-btn{
        color: #808695;
        &:hover{
            color: #17233d;
        }
    }

    ::v-deep .input-err .el-input__inner{
        border-color: #F56C6C!important;
    }
</style>
